import React, { PureComponent } from 'react';

export class Main extends PureComponent {
  render() {
    return <div>Main</div>;
  }
}

export default Main;
